<template>
  <div class="skill-checking">
    <img src="~@/assets/images/skill-validating.png">
    <p>
      <span>申請審核中...</span>
      <span>小貼士：</span>
      <span>1.審核結果會在工作日24小時內給出</span>
      <span>2.審核結果會通過站內系統通知形式告知，記得查看喔~</span>
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.skill-checking {
  background: white;
  margin-top: 60px;
  height: 500px;
  border-radius: 8px;
  padding-top: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    display: block;
    width: 230px;
    height: 104px;
    margin-right: 80px;
  }

  p {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #333333;
    span {
      margin-bottom: 5px;
      &:first-child {
        font-weight: 500;
        line-height: 31px;
        font-size: 22px;
        color: #333;
        margin-bottom: 15px;
        text-align: center;
      }
    }
  }
}
</style>